import dynamic from "next/dynamic";
import MasonryGridConfig from "./masonry-grid-config";
import MasonryGridAdvancedConfig from "./masonry-grid-advanced-config";
const MasonryGridComponent = dynamic(()=>import("./masonry-grid-component"));
export default {
    MasonryGridComponent,
    MasonryGridConfig,
    MasonryGridAdvancedConfig
};
